/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noisy_Trick_Manatee_TwistInputs */

const fr_noisy_trick_manatee_twist = /** @type {(inputs: Noisy_Trick_Manatee_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu es déjà inscrits a un autre cours ce jours ci. Tu peux t'inscrire sans décompter de séance.`)
};

/**

* @param {Noisy_Trick_Manatee_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const noisy_trick_manatee_twist = /** @type {((inputs?: Noisy_Trick_Manatee_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noisy_Trick_Manatee_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_noisy_trick_manatee_twist(inputs)
});